import React from 'react';
import {Anchor, Breadcrumbs} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import S from './Article4.module.scss';
import article1 from "../../shared/assets/images/article1.png";
import article2 from "../../shared/assets/images/article2.png";
import article3 from "../../shared/assets/images/article3.png";
import article4 from "../../shared/assets/images/article4.png";

export const Article4 = () => {
    const navigate = useNavigate();

    const items = [
        { title: 'Главная', url: '/' },
        { title: 'Статьи', url: '/articles-list' },
        { title: 'Статья', active: true },
    ].map((item, index) => (
        <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
            {item.title}
        </Anchor>
    ));
    return (
        <section id='article4'>
            <div className={S.content}>
                <div>
                    <Breadcrumbs>
                        {items}
                    </Breadcrumbs>
                    <div className={S.infoDiv}>
                        <div className={S.title}>ЦИФРОВИЗАЦИЯ В ОБУЧЕНИИ РЕМОНТНИКОВ УРАЛЬСКОЙ СТАЛИ</div>
                        <div className={S.picture}>
                            <img src={article4} alt="article4"/>
                        </div>
                        <div className={S.textDiv}>
                            <div className={S.text}>
                                На комбинате «Уральская Сталь» (входит в Группу компаний «Уральская Сталь» совместно с
                                Загорским трубным заводом) специалистов по техническому обслуживанию и ремонтам помогают
                                обучать виртуальные 3D и VR-технологии. На приобретение тренажеров и разработку
                                программного обеспечения направлено 12 млн руб.
                            </div>
                            <div className={S.text}>
                                Проект по разработке и внедрению программного обеспечения на базе виртуальных технологий
                                был запущен на комбинате два года назад для повышения эффективности работы ремонтного
                                персонала. Программисты улучшили детализацию технологического процесса и мультиплеер,
                                позволяющий погрузиться в более сложные ремонты, где одновременно работает персонал
                                разных профессий. Продолжат увеличивать перечень ремонтных операций в соответствии с
                                каталогом агрегатов, которые ремонтируются на предприятии.
                            </div>
                            <div className={S.text}>
                                Оборудование состоит из шлемов виртуальной реальности с контроллерами управления,
                                обзорных мониторов и компьютеров. В основе – программное обеспечение, разработанное
                                сотрудниками ИТ-центра комбината. Надевая шлем, обучаемый попадает в ремонтную
                                мастерскую, где есть рабочий стол для сборки, шкафы, инструменты и мостовой кран для
                                перемещения редуктора. В обучающей версии тренажёра заложены подсказки, которые помогают
                                освоить порядок демонтажа деталей и необходимый инструмент. Звуковым сигналом система не
                                позволит нарушить правила безопасности и системы 5С или выполнить действие, которое не
                                соответствует технологии ремонта. По окончании обучения тренажёр переключают в режим
                                экзамена. За действиями стажёра на большом мониторе наблюдает куратор.
                            </div>
                            <div className={S.text}>
                                Для проведения занятий были оснащены два класса с полным набором требуемого
                                оборудования. Обучение уже прошли более 60 человек. Система не является стационарной и,
                                при необходимости, может быть использована для обучения в любом месте и в любое время.
                                Следом за ремонтниками на 3D и VR-тренажёре планируется обучать электромонтёров.
                            </div>
                            <div className={S.text}>
                                Данные тренажёры являются уникальным инструментом развития профессиональных навыков
                                специалистов без нарушений технологии ремонта и норм промышленной безопасности.
                                Потраченные на оборудование средства окупятся за счёт снижения рисков ошибочных действий
                                и повышения мастерства персонала.
                            </div>
                            <div className={S.hrefDiv}>
                                <span className={S.textBold}>Источник:</span>
                                <a href="https://www.metalinfo.ru/ru/news/168253"
                                >https://www.metalinfo.ru/ru/news/168253</a>
                            </div>
                        </div>
                        <div className={S.articleTitleDiv}>Читайте также</div>
                        <div className={S.articlesDiv}>
                            <div className={S.articleDiv} onClick={() => navigate('/article1')}>
                                <div className={S.pictureArticle}>
                                    <img src={article1} alt="article1"/>
                                </div>
                                <div className={S.articleDivText}>Ольга Калашникова, начальник управления экологии ПАО
                                    «Северсталь»: «Будущее
                                    принадлежит
                                </div>
                                <p className={S.articleDivDate}>26.02.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article2')}>
                                <div className={S.pictureArticle}>
                                    <img src={article2} alt="article2"/>
                                </div>
                                <div className={S.articleDivText}>Цифровизация экономических отношений в энергетике
                                </div>
                                <p className={S.articleDivDate}>24.04.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article3')}>
                                <div className={S.pictureArticle}>
                                    <img src={article3} alt="article3"/>
                                </div>
                                <div className={S.articleDivText}>Ум, сталь и трубы нашей эпохи</div>
                                <p className={S.articleDivDate}>25.06.2025</p>
                            </div>
                        </div>
                    </div>
                    <div className={S.footer}>
                        <div onClick={() => navigate('/articles-list')}>← Назад к списку</div>
                    </div>
                </div>
            </div>
        </section>
    )
}